import React, { useRef } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import Reveal, { Eyebrow } from "../common/Reveal";
import { testimonials } from "../../mock";

export default function Testimonials() {
  const scroller = useRef(null);
  const scrollBy = (dir) => {
    scroller.current?.scrollBy({ left: dir * 420, behavior: "smooth" });
  };

  return (
    <section id="stories" className="bg-lybl-green py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex items-end justify-between gap-6">
          <div>
            <Reveal><p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-white/50">{testimonials.eyebrow}</p></Reveal>
            <Reveal delay={80}><h2 className="mt-4 font-serif text-4xl lg:text-5xl text-white">{testimonials.title}</h2></Reveal>
          </div>
          <div className="hidden sm:flex gap-3">
            <button onClick={() => scrollBy(-1)} className="h-11 w-11 rounded-full border border-white/25 text-white flex items-center justify-center hover:bg-white/10 transition-colors" aria-label="Previous"><ChevronLeft className="h-5 w-5" /></button>
            <button onClick={() => scrollBy(1)} className="h-11 w-11 rounded-full border border-white/25 text-white flex items-center justify-center hover:bg-white/10 transition-colors" aria-label="Next"><ChevronRight className="h-5 w-5" /></button>
          </div>
        </div>

        <div ref={scroller} className="mt-12 flex gap-6 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-2">
          {testimonials.items.map((t) => (
            <div key={t.meta} className="snap-start shrink-0 w-[85%] sm:w-[420px] rounded-3xl bg-lybl-paper p-8 flex flex-col">
              <div className="flex gap-1 text-lybl-rust">
                {Array.from({ length: 5 }).map((_, i) => <Star key={i} className="h-4 w-4 fill-current" />)}
              </div>
              <p className="mt-5 text-[15px] text-lybl-ink/85 leading-relaxed flex-1">“{t.text}”</p>
              <div className="mt-6 flex items-center gap-3">
                <img src={t.image} alt="" className="h-11 w-11 rounded-full object-cover" />
                <div>
                  <p className="font-medium text-lybl-ink text-[14px]">{t.who}</p>
                  <p className="text-[13px] text-lybl-muted">{t.meta}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
